/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";

const SharePointSiteDialog = ({
  isSiteChangeDialogOpen,
  setIsSiteChangeDialogOpen,
  isMigrationActionLoading,
  isFetchingDrives,
  pendingDriveSelection,
  setPendingDriveSelection,
  availableDrives,
  handleConfirmSiteChange,
  selectedOrgObj,
}: any) => {
  return (
    <Dialog
      open={isSiteChangeDialogOpen}
      onClose={() =>
        !isMigrationActionLoading && setIsSiteChangeDialogOpen(false)
      }
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <StorageIcon color="warning" />
        Change Target SharePoint Site
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="body2" fontWeight={600} gutterBottom>
            Direct Migration Warning
          </Typography>
          <Typography variant="body2">
            Changing the target site will automatically trigger a
            background migration. All existing files in the current site
            will be moved directly to the newly selected site.
          </Typography>
        </Alert>

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Select New Destination:
        </Typography>
        {isFetchingDrives ? (
          <Box display="flex" alignItems="center" gap={1}>
            <CircularProgress size={20} />
            <Typography variant="body2">
              Fetching available sites from Microsoft 365...
            </Typography>
          </Box>
        ) : (
          <FormControl fullWidth size="small">
            <InputLabel>SharePoint Site</InputLabel>
            <Select
              value={pendingDriveSelection}
              onChange={(e) =>
                setPendingDriveSelection(e.target.value as string)
              }
              label="SharePoint Site"
            >
              {availableDrives.map((drive) => (
                <MenuItem key={drive.driveId} value={drive.driveId}>
                  {drive.siteName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button
          onClick={() => setIsSiteChangeDialogOpen(false)}
          disabled={isMigrationActionLoading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleConfirmSiteChange}
          startIcon={
            isMigrationActionLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <StorageIcon />
            )
          }
          disabled={
            isMigrationActionLoading ||
            isFetchingDrives ||
            !pendingDriveSelection ||
            pendingDriveSelection ===
              selectedOrgObj?.storageSettings?.sharepointDriveId
          }
        >
          {isMigrationActionLoading ? "Starting..." : "Confirm & Migrate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SharePointSiteDialog;
